import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyTitle,
} from '@/components/ui/empty'
import { Input } from '@/components/ui/input'

type CraEmptyStepPageProps = {
  titleKey: string
  descriptionKey: string
  emptyTitleKey?: string
  buttonKeys?: string[]
  i18nNamespace?: string
}

export function CraEmptyStepPage({
  titleKey,
  descriptionKey,
  emptyTitleKey,
  buttonKeys = [],
  i18nNamespace = 'machineryDirectiveCompliance',
}: CraEmptyStepPageProps) {
  const { t } = useTranslation(i18nNamespace)
  const [draft, setDraft] = useState('')

  return (
    <div className='flex h-full flex-col space-y-4'>
      <h1 className='text-2xl font-semibold tracking-tight'>{t(titleKey)}</h1>
      <Empty className='min-h-[320px] rounded-lg border border-dashed'>
        <EmptyHeader>
          <EmptyTitle>{t(emptyTitleKey ?? titleKey)}</EmptyTitle>
          <EmptyDescription>{t(descriptionKey)}</EmptyDescription>
        </EmptyHeader>
        <EmptyContent>
          <Input
            value={draft}
            onChange={(event) => {
              setDraft(event.target.value)
            }}
            aria-label={t(titleKey)}
          />
          {buttonKeys.length > 0 ? (
            <div className='flex flex-wrap justify-center gap-2'>
              {buttonKeys.map((key) => (
                <Button key={key} type='button' size='sm' variant='outline'>
                  {t(key)}
                </Button>
              ))}
            </div>
          ) : null}
        </EmptyContent>
      </Empty>
    </div>
  )
}
